import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ExecutionHistoryService } from '@app/execution-history/execution-history.service';
import { combineLatest } from 'rxjs';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateAdapterService } from '@app/_services/custom-date-adapter.service';
import { NgbDateCustomParserFormatter } from '@app/_shared/date-formatter.service';
import { AuthenticationService, CommonService } from '@app/_services';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-exec-history',
  templateUrl: './exec-history.component.html',
  styleUrls: ['./exec-history.component.less'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomDateAdapterService },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ]
})
export class ExecHistoryComponent implements OnInit {

  users: any
  page: number = 1;
  pageSize: number = 15;
  historyListSearchForm: FormGroup;
  executionsList: any = [];
  collectionSize = 0;
  previousPage: any;
  mastersuiteDetails: any = {};
  executionStatusList: any;
  minDate: NgbDateStruct;
  maxDate: any;
  execTypes: any = [];

  constructor(private titleService: Title,private AuthService: AuthenticationService, private router: Router, private executionHistoryService: ExecutionHistoryService, private route: ActivatedRoute, private formBuilder: FormBuilder,
    private commonService : CommonService, private toastr: ToastrService) { }

  ngOnInit() {
    this.getUsers();
    this.executionStatusList = JSON.parse(localStorage.getItem('about')).executionStatuses;
    this.execTypes = JSON.parse(localStorage.getItem('about')).execTypes;
    let index = this.execTypes.indexOf("CI_CD_PIPELINE");
    this.execTypes.splice(index,1);
    this.setMaxDate();
    this.initialiseHistorySearchForm();
    this.mastersuiteDetails = this.route.snapshot.data['details'].response;
    this.AuthService.getUserRoleByProject(this.mastersuiteDetails.role);
    this.titleService.setTitle('MS | Execution History');
    this.route.queryParams.subscribe(() => {
      this.getMasterSuiteExecutionHistory();
    });
  }

  getUsers() {
    this.executionHistoryService.getUsersList().pipe().subscribe(data => {
      if (data.code === 200) {
        this.users = data.response;
      }
    });
  }

  initialiseHistorySearchForm() {
    this.historyListSearchForm = this.formBuilder.group({
      executedBy: null,
      executionStatus: null,
      fromDate: null,
      toDate: null,
      executionType: 'MASTER_SUITE',
      execType: null,
      executionTaskSqlId: this.route.snapshot.params.id
    });
  }

  setSearchFormParams(params: any) {
    if (params.executedBy) { this.historyListSearchForm.get('executedBy').setValue(JSON.parse(params.executedBy)); }
    if (params.executionStatus) { this.historyListSearchForm.get('executionStatus').setValue(params.executionStatus); }
    if (params.execType) { this.historyListSearchForm.get('execType').setValue(params.execType); }
    if (params.fromDate) { this.historyListSearchForm.get('fromDate').setValue(params.fromDate); }
    if (params.toDate) { this.historyListSearchForm.get('toDate').setValue(params.toDate); }
    if (params.projectIds) {
      let projects = [];
      if (Array.isArray(params.projectIds)) {
        projects = params.projectIds.map((val) => {
          return parseInt(val, 10);
        });
      } else {
        const projectId = parseInt(params.projectIds, 10);
        projects.push(projectId);
      }
      this.historyListSearchForm.get('projectIds').setValue(projects);
    }
  }

  getMasterSuiteExecutionHistory() {
    let searchParams = this.route.snapshot.queryParams;
    const collection = {
      page: this.page || 1,
      size: this.pageSize || 15,
      executionType: 'MASTER_SUITE',
      executionTaskSqlId: this.route.snapshot.params.id
    };
    this.setSearchFormParams(searchParams);
    searchParams = { ...collection, ...searchParams };
    this.executionHistoryService.getExecutionHistory(searchParams).pipe().subscribe(data => {
      if (data.code == 200) {
        this.executionsList = data.response.masterSuites;
        this.collectionSize = data.response.count;
      } else if (data.code == 204) {
        this.executionsList = [];
        this.collectionSize = 0;
      }
    });
  }

  pagination() {
    let searchParams = this.historyListSearchForm.value;
    const collection = {
      page: this.page || 1,
      size: this.pageSize || 15,
      executionType: 'MASTER_SUITE',
      executionTaskSqlId: this.route.snapshot.params.id
    };
    searchParams = { ...collection, ...searchParams };
    console.log(searchParams)
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: searchParams });
  }

  onPageChange(page: number) {
    if (page !== this.previousPage) {
      this.previousPage = page;
      this.pagination();
    }
  }

  onSizeChange(size: number): void {
    this.pageSize = size;
    this.pagination();
  }

  setMaxDate() {
    this.maxDate = { year: new Date().getFullYear(), month: (new Date().getMonth() + 1), day: new Date().getDate() };
  }

  setMindate() {
    if (null === this.historyListSearchForm.value.fromDate) {
      this.historyListSearchForm.get('toDate').setValue(null);
    }
    const date = new Date(this.historyListSearchForm.value.fromDate);
    this.minDate = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
  }

  exportExtractedGlobalTestData(execution : any) {
    this.commonService.exportExtractedGlobalTestData(execution.executedTaskId, 'MASTER_SUITE').pipe().subscribe((data: any) => {
      if (data.code === 200) {
        const d = this.base64ToArrayBuffer(data.response);
        const blob = new Blob([d], {
          type: 'application/vnd.ms-excel'
        });
        const url = window.URL.createObjectURL(blob);

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, 'MASTERSUIT_' + this.mastersuiteDetails.name.replace(/ /g,"_") + '_' + execution.noSqlId + '.csv');
        } else {
          const a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = 'MASTERSUIT_' + this.mastersuiteDetails.name.replace(/ /g,"_") + '_' + execution.noSqlId + '.csv';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
        this.toastr.info(data.message);
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  base64ToArrayBuffer(data): Uint8Array {
    const binaryString = window.atob(data);
    const binLength = binaryString.length;
    const bytes = new Uint8Array(binLength);
    for (let i = 0; i < binLength; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }

  clearSearchFilter() {
    this.historyListSearchForm.reset();
    this.pagination();
  }

}
